<template>
  <div class="q-mt-md q-ml-sm">
    <div class="q-ml-md q-mt-md">
      <img
        class="img-mao"
        v-show="props.mao == 'direita'"
        src="../../assets/mao02.svg"
        usemap="map"
      />
      <img
        class="img-mao"
        v-show="props.mao == 'esquerda'"
        src="../../assets/mao01.svg"
        usemap="map"
      />
      <map class="map" name="map">
        <div class="poly1">
          <div
            v-show="props.mao == 'direita'"
            class="polegar-direito dedo"
            @click="
              selecionarDedo({
                label: 'Polegar Direito',
                value: 'RightThumb',
                classDedo: 'polegar-direito',
              })
            "
          ></div>
          <div
            v-show="props.mao == 'esquerda'"
            class="polegar-esquerdo dedo"
            @click="
              selecionarDedo({
                label: 'Polegar Esquerdo',
                value: 'LeftThumb',
                classDedo: 'polegar-esquerdo',
              })
            "
          ></div>
        </div>
        <div class="poly2">
          <div
            v-show="props.mao == 'direita'"
            class="indicador-direito dedo"
            @click="
              selecionarDedo({
                label: 'Indicador Direito',
                value: 'RightIndex',
                classDedo: 'indicador-direito',
              })
            "
          ></div>
          <div
            class="indicador-esquerdo dedo"
            v-show="props.mao == 'esquerda'"
            @click="
              selecionarDedo({
                label: 'Indicador Esquerdo',
                value: 'LeftIndex',
                classDedo: 'indicador-esquerdo',
              })
            "
          ></div>
        </div>
        <div class="poly3">
          <div
            class="medio-direito dedo"
            v-show="props.mao == 'direita'"
            @click="
              selecionarDedo({
                label: 'Médio Direito',
                value: 'RightMiddle',
                classDedo: 'medio-direito',
              })
            "
          ></div>
          <div
            v-show="props.mao == 'esquerda'"
            class="medio-esquerdo dedo"
            @click="
              selecionarDedo({
                label: 'Médio Esquerdo',
                value: 'LeftMiddle',
                classDedo: 'medio-esquerdo',
              })
            "
          ></div>
        </div>
        <div class="poly4">
          <div
            class="anelar-direito dedo"
            v-show="props.mao == 'direita'"
            @click="
              selecionarDedo({
                label: 'Anelar Direito',
                value: 'RightRing',
                classDedo: 'anelar-direito',
              })
            "
          ></div>
          <div
            class="anelar-esquerdo dedo"
            v-show="props.mao == 'esquerda'"
            @click="
              selecionarDedo({
                label: 'Anelar Esquerdo',
                value: 'LeftRing',
                classDedo: 'anelar-esquerdo',
              })
            "
          ></div>
        </div>
        <div class="poly5">
          <div
            class="minimo-direito dedo"
            v-show="props.mao == 'direita'"
            @click="
              selecionarDedo({
                label: 'Mínimo Direito',
                value: 'RightPinky',
                classDedo: 'minimo-direito',
              })
            "
          ></div>
          <div
            class="minimo-esquerdo dedo"
            v-show="props.mao == 'esquerda'"
            @click="
              selecionarDedo({
                label: 'Mínimo Esquerdo',
                value: 'LeftPinky',
                classDedo: 'minimo-esquerdo',
              })
            "
          ></div>
        </div>
      </map>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, onMounted, watch, defineEmits } from "vue";

const props = defineProps({
  mao: {
    type: String,
    default: "esquerda",
  },
  tipoMetodo: {
    type: String,
    default: "cadastro",
  },
  indiceDedosCadastrados: {
    type: Array,
  },
  desablilitado: {
    type: Boolean,
    default: false,
  },
  removerDedos: {
    type: Number,
  },
});

const emits = defineEmits(["enviarDedoSelecionado"]);

const indiceDedos = ref({
  1: "polegar-direito",
  2: "indicador-direito",
  3: "medio-direito",
  4: "anelar-direito",
  5: "minimo-direito",
  6: "polegar-esquerdo",
  7: "indicador-esquerdo",
  8: "medio-esquerdo",
  9: "anelar-esquerdo",
  10: "minimo-esquerdo",
});

const selecionarDedo = (dedoObject, cadastrados = false) => {
  if (props.desablilitado) {
    return;
  }
  if (dedoObject === undefined || dedoObject === null) {
    return;
  }
  let map = document.querySelectorAll(".dedo");
  if (!cadastrados) {
    map.forEach((value) => {
      let classDedo = value.className.split(" ")[0];

      if (classDedo != dedoObject.classDedo) {
        value.classList.remove("selecionado");
      } else {
        value.classList.add("selecionado");
        emits("enviarDedoSelecionado", dedoObject);
      }
    });
    return;
  }
  document.querySelector(`.${dedoObject}`).classList.add("cadastrado");
};

const selecionarDedosCadastrados = () => {
  props.indiceDedosCadastrados.forEach((dedo) => {
    selecionarDedo(indiceDedos.value[dedo], true);
  });
};

watch(
  () => props.indiceDedosCadastrados,
  () => {
    selecionarDedosCadastrados();
  }
);

onMounted(() => {
  selecionarDedosCadastrados();
});

const removerDedos = () => {
  let map = document.querySelectorAll(".dedo");
  map.forEach((value) => {
    value.classList.remove("selecionado");
  });
};

watch(
  () => props.removerDedos,
  () => {
    removerDedos();
  }
);
</script>

<style scoped>
.img-mao {
  height: 280px;
  width: 280px;
}
.poly1 {
  position: relative;
}
.polegar-direito {
  position: absolute;
  top: -178px;
  left: 207px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.polegar-esquerdo {
  position: absolute;
  top: -178px;
  left: 43px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.poly2 {
  position: relative;
}
.indicador-direito {
  position: absolute;
  top: -272px;
  left: 146px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  cursor: pointer;
}
.indicador-esquerdo {
  position: absolute;
  top: -271px;
  left: 106px;
  width: 26px;
  height: 26px;
  border-radius: 100px;
  cursor: pointer;
}
.poly3 {
  position: relative;
}
.medio-direito {
  position: absolute;
  top: -286px;
  left: 107px;
  width: 26px;
  height: 26px;
  border-radius: 100px;
  cursor: pointer;
}
.medio-esquerdo {
  position: absolute;
  top: -286px;
  left: 148px;
  width: 26px;
  height: 26px;
  border-radius: 100px;
  cursor: pointer;
}
.poly4 {
  position: relative;
}
.anelar-direito {
  position: absolute;
  top: -265px;
  left: 70px;
  width: 26px;
  height: 26px;
  border-radius: 100px;
  cursor: pointer;
}
.anelar-esquerdo {
  position: absolute;
  top: -265px;
  left: 184px;
  width: 26px;
  height: 26px;
  border-radius: 100px;
  cursor: pointer;
}
.poly5 {
  position: relative;
}
.minimo-esquerdo {
  position: absolute;
  top: -234px;
  left: 212px;
  width: 26px;
  height: 26px;
  border-radius: 100px;
  cursor: pointer;
}
.minimo-direito {
  position: absolute;
  top: -234px;
  left: 43px;
  width: 26px;
  height: 26px;
  border-radius: 100px;
  cursor: pointer;
}
.polegar-direito:hover {
  background: yellow;
  opacity: 0.7;
}
.polegar-esquerdo:hover {
  background: yellow;
  opacity: 0.7;
}
.indicador-direito:hover {
  background: yellow;
  opacity: 0.7;
}
.indicador-esquerdo:hover {
  background: yellow;
  opacity: 0.7;
}
.medio-direito:hover {
  background: yellow;
  opacity: 0.7;
}
.medio-esquerdo:hover {
  background: yellow;
  opacity: 0.7;
}
.anelar-direito:hover {
  background: yellow;
  opacity: 0.7;
}
.anelar-esquerdo:hover {
  background: yellow;
  opacity: 0.7;
}
.minimo-direito:hover {
  background: yellow;
  opacity: 0.7;
}
.minimo-esquerdo:hover {
  background: yellow;
  opacity: 0.7;
}
.selecionado {
  background: yellow;
  opacity: 0.7;
  z-index: 10;
}
.cadastrado {
  background: #85d546;
  opacity: 0.8;
  z-index: 1;
}
.cadastrado.selecionado {
  background: yellow !important;
  opacity: 0.7 !important;
  z-index: 10 !important;
}
</style>
